import { Box, Container, Typography } from "@mui/material";

const Docs = () => (
    <Container maxWidth="md" sx={{ py: 6 }}>
        <Typography variant="h3" sx={{ mb: 2, color: "#052F5D" }}>
            DWMS EMR Documentation
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
            Operational documentation for Dr. Wilburg's Medical Services
            Electronic Medical Records platform will appear here.
        </Typography>
        <Box sx={{ mt: 4 }}>
            <Typography variant="h5" sx={{ mb: 1 }}>Default Admin Credentials</Typography>
            <Typography variant="body2" color="text.secondary">
                Set up via the seedAdmin script on first deployment. See the
                operations runbook for credentials provisioned to your instance.
            </Typography>
        </Box>
    </Container>
);

export default Docs;
